<template>
  <table class="tb-col">
    <colgroup>
      <col style="width: auto" />
      <col style="width: 20%" />
      <col style="width: 20%" />
    </colgroup>
    <thead>
    <tr>
      <th>서비스 내용</th>
      <th>과금기준</th>
      <th class="last">금액</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(gds, index) in gdses"
        :key="'gds_' + gds.gdsDpId">
      <td v-if="index == 0"
          :rowspan="gdses.length"
          style="text-align: left;">
        <ul class="txt-type2 depth1"
            v-for="{fnctId, fnctDc} in fncts"
            :key="'fnct_' + fnctId">
          <li>{{ fnctDc }}</li>
        </ul>
      </td>
      <td>{{ gds.dpSvcDc }}</td>
      <td class="last">{{ $cmmn.number.addComma(gds.svcAmt) }}원</td>
    </tr>
    </tbody>
  </table>
  <div class="info-txt-bottom">
    <ul style="display: flex; flex-direction: column;">
      <li style="display: inline-flex;">
        <span class="info1">
          <span class="pc01">매월 이용료는 익월 15일에 결제됩니다.</span>(※주말 및 공휴일은 익영업일에 결제가 이루어집니다.)
        </span>
      </li>
      <li style="display: inline-flex;">
        <span class="info1">
          <span class="pc01">매월 원천세 신고 인원 수</span>에 따라 요금이 변동됩니다
        </span>
      </li>
      <li style="display: inline-flex; padding-left: 20px;">
        ※ 원천세 신고 인원 수 : 일용직 포함
      </li>
    </ul>
  </div>
</template>

<script setup>
import {onMounted, ref, defineExpose} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$axios, $cmmn} = getUtils();
const {$loading} = getStore();

const gdses = ref([]);
const getSvcGdsesBySvcId = async () => {
  const svcId = $cmmn.svc.getSeroiSvcId();
  const gdsId = $cmmn.svc.getSeroiBsSvcGdsId();
  const {data} = await $axios.get('/api/svc/gdses/by-svc-id', {params: {svcId, gdsId}});
  gdses.value = data;
}

const fncts = ref([]);
const getSvcFnctsBySvcId = async () => {
  const svcId = $cmmn.svc.getSeroiSvcId();
  const {data} = await $axios.get('/api/svc/fncts/by-svc-id', {params: {svcId}});
  fncts.value = data;
}

const init = async () => {
  await Promise.all([getSvcGdsesBySvcId(), getSvcFnctsBySvcId()]);
}

const getGdsId = () => {
  let gdsId = '';
  if (gdses.value) gdsId = gdses.value[0].gdsId;
  return gdsId;
}

defineExpose({
  getGdsId
})

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>


<style scoped>

</style>
